var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-playAudio appearAnimationA",on:{"click":function($event){return _vm.playAudioVoiced()}}})}
var staticRenderFns = []

export { render, staticRenderFns }